export const fetchToken = async ({ clientId, code, state, tokenEndpoint, fetch = window.fetch, clientSecret }) => {
  const payload: Record<string, string> = {
    client_id: clientId,
    code,
    grant_type: 'authorization_code',
    code_verifier: state.encodedVerifier,
    redirect_uri: state.redirectUri,
    challenge_method: 'sha256',
    client_secret: clientSecret,
  };
  // eslint-disable-next-line no-undef
  const fetchOptions: RequestInit = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    body: new window.URLSearchParams(payload),
  };

  try {
    const fetchResponse = await fetch(tokenEndpoint, fetchOptions);
    if (fetchResponse.ok) {
      const token = await fetchResponse.json();
      const { expires_in } = token;
      if (expires_in && Number.isFinite(expires_in)) {
        const slackSeconds = 10;
        token.expires_at = new Date(new Date().getTime() + expires_in * 1000 - slackSeconds * 1000);
        sessionStorage.setItem('expires_at', token.expires_at);
      }
      return token;
    } else {
      console.log('Error', fetchResponse);
      throw Error('Error while fetching token from the provider');
    }
  } catch (e) {
    console.log('Error during fetching Token. Error Response', e);
    throw e;
  }
};
export const refreshToken = async () => {
  const clientId = process.env.REACT_APP_CLIENT_ID ? process.env.REACT_APP_CLIENT_ID : '';
  const provider = process.env.REACT_APP_PROVIDER ? process.env.REACT_APP_PROVIDER : '';
  const tokenEndpoint = process.env.REACT_APP_PROVIDER_TOKEN_ENDPOINT
    ? process.env.REACT_APP_PROVIDER_TOKEN_ENDPOINT
    : '';
  const payload: Record<string, any> = {
    client_id: clientId,
    grant_type: 'refresh_token',
    refresh_token: sessionStorage.getItem('REFRESH_TOKEN'),
  };
  // eslint-disable-next-line no-undef
  const fetchOptions: RequestInit = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    body: new window.URLSearchParams(payload),
  };
  const fetchResponse = await fetch(`${provider}${tokenEndpoint}`, fetchOptions);
  const token = await fetchResponse.json();
  sessionStorage.removeItem('API_TOKEN');
  sessionStorage.setItem('API_TOKEN', token['access_token']);
  sessionStorage.removeItem('REFRESH_TOKEN');
  sessionStorage.setItem('REFRESH_TOKEN', token['refresh_token']);
  return token;
};
